import DownloadIcon from '@mui/icons-material/Download';
import {
  Box,
  Button,
  Card,
  Chip,
  Divider,
  Paper,
  Typography,
} from '@mui/material';
import getSymbolFromCurrency from 'currency-symbol-map';
import React from 'react';
import AxiosConfig from '../../../../../config/AxiosConfig';
import b64toBlob from '../../../../helpers/utils/blob';
import ActionOnCommandIcon from '../../../svg-icons/ActionOnCommandIcon';
import RefundAskIcon from '../../../svg-icons/RefundAskIcon';

const RefundRecap = ({ refund, currency }) => {
  if (!refund || refund?.isDraft) {
    return null;
  }
  // console.log(refund);
  const handleDownloadRIB = async () => {
    try {
      await AxiosConfig.create('get', `/refunds/${refund?._id}/downloadRIB`)
        .call()
        .exit((res) => {
          const content = res.data;
          if (content?.length > 0) {
            const blobContent = b64toBlob(
              content?.split(',')[1]?.replace(/_/g, '/')?.replace(/-/g, '+'),
              refund?.rib?.mimeType
            );
            const blobUrl = URL.createObjectURL(blobContent);
            const link = document.createElement('a');
            link.setAttribute(
              'download',
              `rib_${refund?.orderRef}_${refund?.rib?.name}`
            );
            link.href = blobUrl;
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
          }
        });
    } catch (error) {
      console.error('Erreur lors du téléchargement du RIB :', error);
    }
  };
  const nameToDisplay =
    refund?.status?.code === 'REFUSEDFI' ||
    refund?.status?.code === 'VALIDATEDFI'
      ? refund?.refundedBy?.firstName + ' ' + refund?.refundedBy?.lastName
      : refund?.status?.code === 'REFUSEDSC'
        ? refund?.validatedBy?.firstName + ' ' + refund?.validatedBy?.lastName
        : refund?.author?.firstName + ' ' + refund?.author?.lastName;

  const getColor = (status) => {
    if (
      status === 'REFUSEDFI' ||
      status === 'REFUSEDSC' ||
      status === 'REFUND_FAILED_BO' ||
      status === 'PARTIAL_REFUND_FAILED' ||
      status === 'REFUND_FAILED'
    ) {
      return 'error';
    }
    if (status === 'REFUND_PENDING' || status === 'PARTIAL_REFUND_PENDING') {
      return 'warning';
    }

    return 'success';
  };

  return (
    <Paper
      elevation={16}
      key={refund?._id}
      sx={{
        padding: 0,
        marginBottom: 1,
        boxShadow: 'none',
      }}
    >
      <Card
        elevation={5}
        sx={{
          display: 'flex',
          gap: 2,
          padding: 1,
          alignItems: 'center',
          justifyContent: 'space-evenly',
          flexDirection: 'column',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <ActionOnCommandIcon fontSize="large" />
            <Typography component={'span'} sx={{ fontSize: '0.9em' }}>
              {nameToDisplay}
            </Typography>
            <Typography
              component={'span'}
              sx={{ fontSize: '0.9em' }}
            >{`Remboursement (${refund?.refundType?.name}) `}</Typography>
            <Typography component={'span'}>
              {refund?.type?.name}
              {refund?.task?._id ? ` (${refund?.task?.action?.name})` : ''}
            </Typography>
            <Typography component={'span'} variant="caption">
              {new Date(refund?.updatedAt).toLocaleString('fr-FR', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
              })}
            </Typography>
          </Box>
          <Divider />
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
            }}
          >
            <RefundAskIcon fontSize="medium" />
            <Chip
              label={refund?.status?.name}
              color={getColor(refund?.status?.code)}
              variant="outlined"
              size="small"
              sx={{ width: 'fit-content', borderRadius: '5px' }}
            />
            {refund?.rib && (
              <Button
                color="primary"
                variant="outlined"
                size="small"
                onClick={handleDownloadRIB}
                endIcon={<DownloadIcon />}
              >
                RIB
              </Button>
            )}
          </Box>
          <Typography
            sx={{
              color: 'primary.main',
              fontWeight: 'bold',
            }}
          >
            {refund?.orderRef}
          </Typography>
          <Typography
            sx={{
              color: 'primary.main',
              fontWeight: 'bold',
            }}
          >
            {refund?.type} {refund?.amountToRefund}
            {getSymbolFromCurrency(currency)}
          </Typography>
          {refund?.refusedDescription ? (
            <Typography
              sx={{
                fontSize: '14px',
              }}
            >
              <span style={{ fontWeight: 'bold' }}>Description du refus:</span>{' '}
              {refund?.refusedDescription}
            </Typography>
          ) : (
            <> </>
          )}
        </Box>
      </Card>
    </Paper>
  );
};

export default RefundRecap;
